import { LOADING_BAR_ENABLE, LOADING_BAR_DISABLE } from '../actionTypes';

export const loadingBarEnable = () => (dispatch) =>
  dispatch({ type: LOADING_BAR_ENABLE });

export const loadingBarDisable = () => (dispatch) =>
  dispatch({ type: LOADING_BAR_DISABLE });
